export default "__VITE_ASSET__db8fdb3d__"